import { Routes } from '@angular/router';
import { AuthenticationGuard } from './core/guards/authentication.guard';
import { environment } from '@environments/environment';
import { ProductDetailPageResolver } from './core/resolver/productDetailPage.resolver';
// Layouts

export const AppRoutes: Routes = [
  {
    path: '',
    data: { title: environment.eddressAppConfig.homePageTitle },
    loadComponent: () => import('./landing/landing.component').then(m => m.LandingComponent),
  },
  {
    path: 'category/:slug',
    data: { breadcrumb: 'Collection', title: 'Category' },
    loadComponent: () => import('./category/category.component').then(m => m.CategoryComponent),
  },
  {
    path: 'category/:slug/:group',
    data: { breadcrumb: 'Collection', title: 'Category' },
    loadComponent: () => import('./category/category.component').then(m => m.CategoryComponent),
  },
  {
    path: 'product/:slug',
    data: { title: 'Product Detail' },
    loadComponent: () => import('./product/product.component').then(m => m.ProductComponent),
    resolve: {
      productDetail: ProductDetailPageResolver,
    },
  },
  {
    path: 'search-products',
    data: { title: 'Search' },
    loadComponent: () => import('./search/search.component').then(m => m.SearchComponent),
  },
  {
    path: 'checkout',
    data: { title: 'Checkout' },
    loadComponent: () => import('./checkout/checkout.component').then(m => m.CheckoutComponent),
  },
  {
    path: 'order-detail/:id',
    data: { title: 'Order Detail' },
    loadComponent: () => import('./order-detail/order-detail.component').then(m => m.OrderDetailComponent),
  },
  {
    path: 'view-cart',
    data: { title: 'View Cart' },
    loadComponent: () => import('./view-cart/view-cart.component').then(m => m.ViewCartComponent),
  },
  {
    path: 'contents/:slug',
    data: { title: '' },
    loadComponent: () => import('./content-page/content-page.component').then(m => m.ContentPageComponent),
  },
  {
    path: 'section-detail/:slug',
    data: { title: '' },
    loadComponent: () => import('./section-detail/section-detail.component').then(m => m.SectionDetailComponent),
  },
  {
    path: 'privacy-policy',
    data: { title: 'Privacy Policy' },
    loadComponent: () => import('./content-page/privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent),
    canActivate: [AuthenticationGuard],
  },
  {
    path: 'about-us',
    data: { title: 'About Us' },
    // redirectTo: 'contents/about-us',
    // pathMatch: 'full',
    loadComponent: () => import('./content-page/about-us/about-us.component').then(m => m.AboutUsComponent),
  },
  {
    path: 'contact-us',
    data: { title: 'Contact Us' },
    loadComponent: () => import('./content-page/contact-us/contact-us.component').then(m => m.ContactUsComponent),
  },
  {
    path: 'payment-return',
    data: { title: 'Payment Return' },
    loadComponent: () => import('./user-information/payments/components/payment-return/payment-return.component').then(m => m.PaymentReturnComponent),
  },
  {
    path: 'user',
    loadComponent: () => import('./user-information/user-information.component').then(m => m.UserInformationComponent),
    children: [
      {
        path: 'my-account',
        data: { title: 'My Account' },
        loadComponent: () => import('./user-information/my-account/my-account.component').then(m => m.MyAccountComponent),
      },
      {
        path: 'orders',
        data: { title: 'Orders' },
        loadComponent: () => import('./user-information/orders/orders.component').then(m => m.OrdersComponent),
      },
      {
        path: 'favorites',
        data: { title: 'Favorites' },
        loadComponent: () => import('./user-information/favorites/favorites.component').then(m => m.FavoritesComponent),
      },
      {
        path: 'addresses',
        data: { title: 'Addresses' },
        loadComponent: () => import('./user-information/addresses/addresses.component').then(m => m.AddressesComponent),
      },
      {
        path: 'payments',
        data: { title: 'Payments' },
        loadComponent: () => import('./user-information/payments/payments.component').then(m => m.PaymentsComponent),
      },
      {
        path: 'my-wallet',
        data: { title: 'My Wallet' },
        loadComponent: () => import('./user-information/my-wallet/my-wallet.component').then(m => m.MyWalletComponent),
      },
      {
        path: 'my-coupon',
        data: { title: 'My Coupon' },
        loadComponent: () => import('./user-information/my-coupon/my-coupon.component').then(m => m.MyCouponComponent),
      },
      {
        path: 'refer-friend',
        data: { title: 'Refer friend' },
        loadComponent: () => import('./user-information/refer-friend/refer-friend.component').then(m => m.ReferFriendComponent),
      },
    ],
  },
  {
    path: '**',
    data: { title: '404 Page Not Found' },
    loadComponent: () => import('./page-not-found.component').then(m => m.PageNotFoundComponent),
  },
];
